import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function HotelHightowerOpen() {
  const dateTexts = ['1892年', '1月', '23日'];
  const title = 'ホテルハイタワー オープン';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/CIMG3729.jpg'
  const description = (
    <>
      <a href='/harrison-hightower-iii'>
        {'ハリソンハイタワー三世'}
      </a>
      {'が、ホテルハイタワーをオープンする。'}
      {'高さは当時のニューヨークで最大の59m、14階建であった。'}
    </>
  );


  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
    />
  );
}

export default HotelHightowerOpen;
